import { QualificationModel } from "@core/models/common/qualification.model";
import { CandidateModel, ICandidate, CandidateSelectedModel, CandidateCanceledModel, CandidateIgnoredModel } from "@core/models/extra";
import { RecruitmentPermanentModel } from "./recruitment-permanent.model";
import { IRecruitmentPermanent, IRecruitment } from "./recruitment.interface";

export class RecruitmentPermanentAdapter {
  constructor(recruitment = {}) {
    this[IRecruitment.permanentJob] = recruitment[IRecruitment.permanentJob];
    this[IRecruitment.candidates] = recruitment[IRecruitment.candidates];

    const selectedCandidates = this.extractSelectedCandidates();
    const currentCandidates = this.extractCurrentCandidates();
    const ignoredCandidates = this.extractIgnoredCandidates();
    const canceledCandidates = this.extractCanceledCandidates();

    return new RecruitmentPermanentModel({
      ...recruitment,
      [IRecruitment.selectedCandidates]: selectedCandidates,
      [IRecruitment.currentCandidates]: currentCandidates,
      [IRecruitment.ignoredCandidates]: ignoredCandidates,
      [IRecruitment.canceledCandidates]: canceledCandidates,
      [IRecruitment.qualificationLabel]: this.getQualification().getLabel(),
      [IRecruitment.precisions]: this.getJob()[IRecruitmentPermanent.precisions],
      // RecruitmentPermanent specifics
      [IRecruitmentPermanent.unlimitedContact]: this.getJob()[IRecruitmentPermanent.unlimitedContact],
      [IRecruitmentPermanent.upfront]: this.getJob()[IRecruitmentPermanent.upfront],
    });
  }

  getJob() {
    return this[IRecruitment.permanentJob] || {};
  }

  getAllCandidates() {
    return this[IRecruitment.candidates] || [];
  }

  getExtraByType(type) {
    return this.getAllCandidates().filter((candidate) => this.getExtraIdByType(type).includes(String(candidate[ICandidate.id])));
  }

  getExtraIdByType(type) {
    return (this.getStatusByExtra()[type] || []).map((id) => String(id));
  }

  getStatusByExtra() {
    return this.getJob()[IRecruitmentPermanent.statusByExtra];
  }

  extractSelectedCandidates() {
    // selected candidates are both contacted and recruited candidates
    const selectedCandidates = [...this.getExtraByType([IRecruitmentPermanent.contact]), ...this.getExtraByType([IRecruitmentPermanent.recruited])];
    const canceledCandidates = this.getExtraByType([IRecruitmentPermanent.extraRefused]);

    return (
      selectedCandidates
        // filter out canceled candidates
        .filter((candidate) => !canceledCandidates.find((cancelCandidate) => cancelCandidate[ICandidate.id] === candidate[ICandidate.id]))
        .map((candidate) => new CandidateSelectedModel(candidate))
    );
  }

  extractCurrentCandidates() {
    const candidates = this.getExtraByType([IRecruitmentPermanent.new]);
    return candidates.map((candidate) => new CandidateModel(candidate));
  }

  extractIgnoredCandidates() {
    const candidates = this.getExtraByType([IRecruitmentPermanent.ignored]);
    return candidates.map((candidate) => new CandidateIgnoredModel(candidate));
  }

  extractCanceledCandidates() {
    const candidates = this.getExtraByType([IRecruitmentPermanent.extraRefused]);
    return candidates.map((candidate) => new CandidateCanceledModel(candidate));
  }

  getQualification() {
    return new QualificationModel(this.getJob()[IRecruitmentPermanent.qualification]);
  }
}
